import React from 'react';
import { Id } from '../../types/Id';
import { StackedRibbonListMinimalProps } from '../../types/StackedRibbonListComponentTypes';
import { RibbonListHandles } from '../List/RibbonListHandles';
import { RibbonListStatic, RibbonListStaticProps } from '../List/RibbonListStatic';
import { RibbonListWrapper } from '../List/RibbonListWrapper';
import { useRibbonListWrapper } from '../List/useRibbonListWrapper';

/**
 * Static-specific props used by StackedRibbonListMinimalStatic.
 */
export type StackedRibbonListMinimalStaticProps<TId extends Id, TItem> = RibbonListStaticProps<
  TId,
  TItem
>;

export interface Props<TId extends Id = Id, TItem = unknown>
  extends StackedRibbonListMinimalProps<TId, TItem>,
    StackedRibbonListMinimalStaticProps<TId, TItem> {}

/**
 * A StackedRibbonList without a header section whose contents are rendered statically in the DOM.
 */
export const StackedRibbonListMinimalStatic = React.memo(
  React.forwardRef(<TId extends Id>(props: Props<TId>, ref: React.Ref<RibbonListHandles>) => {
    const { ribbonListProps, ribbonListWrapperProps } = useRibbonListWrapper(props);

    const { height, maxHeight } = props;

    return (
      <RibbonListWrapper {...ribbonListWrapperProps}>
        <RibbonListStatic ref={ref} {...ribbonListProps} height={height} maxHeight={maxHeight} />
      </RibbonListWrapper>
    );
  }),
) as <TId extends Id, TItem>(
  props: Props<TId, TItem> & { ref?: React.Ref<RibbonListHandles> },
) => JSX.Element;
